export const COPILOT_ACTIONS = {
	REDEEM_ACCESS_CODE: "redeemAccessCode",
	RESEND_ACCESS_CODES: "resendAccessCodes",
	GET_PURCHASES: "getPurchases",
	MATCH_EMAIL: "matchEmail",
	CONTACT_SUPPORT: "contactSupport",
} as const;

export const COPILOT_ACTION_DESCRIPTIONS = {
	[COPILOT_ACTIONS.REDEEM_ACCESS_CODE]: "Verify and redeem the access code",
	[COPILOT_ACTIONS.RESEND_ACCESS_CODES]:
		"Verify Order ID and resend the access codes to the user",
	[COPILOT_ACTIONS.GET_PURCHASES]:
		"Get the purchases/access codes associated with the user's account",
	[COPILOT_ACTIONS.MATCH_EMAIL]:
		"Match the email of the logged in email of the user with the email that user is asking to redeem the code for/fetch details.",
	[COPILOT_ACTIONS.CONTACT_SUPPORT]:
		"Reach out to support OR Contact the support team OR Escalate the problem/issue",
};
